var anchor = document.getElementsByClassName('subnav')[0];

if (anchor){
    anchor.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}